var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cols},_vm._l((_vm.dataSources),function(source,index){return _c('div',{key:index,staticClass:"data-labels",class:source.selected ? 'selected-source' : '',staticStyle:{"float":"right"},on:{"click":function($event){return _vm.selectDataSource(source.name)}}},[_vm._v(_vm._s(source.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }